import { Injectable } from '@angular/core';
import { EntityType } from '@epicuro-next/data/engagement/engagement-models';
import { updateLookBook } from '@epicuro-next/state/lookbook-entities';
import { actions } from '@epicuro-next/state/news-feed-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';

import { updateLookBookNewsFeedId } from './news-feed.actions';

@Injectable()
export class NewsFeedShopTheLookEffects {
  public createArticleSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.createArticleSuccess),
      filter(({ article }) => article.type === EntityType.LookBook),
      map(({ article }) =>
        updateLookBookNewsFeedId({
          lookBookId: article.referenceId,
          newsfeedId: article.id,
        }),
      ),
    ),
  );

  public deleteArticleSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.deleteArticleSuccess),
      filter(({ referenceType }) => referenceType === EntityType.LookBook),
      map(({ referenceId }) =>
        updateLookBookNewsFeedId({
          lookBookId: referenceId,
          newsfeedId: undefined,
        }),
      ),
    ),
  );

  public updateOpenedLookBookNewsFeedId = createEffect(() =>
    this.actions$.pipe(
      ofType(updateLookBookNewsFeedId),
      filter(({ lookBookId }) => isNonNullish(lookBookId)),
      map(({ lookBookId, newsfeedId }) =>
        updateLookBook({
          lookBookId: lookBookId as string,
          partialLookBook: { newsfeedId },
        }),
      ),
    ),
  );

  constructor(private actions$: Actions) {}
}
